/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import integrationFieldsetTemplate from './integration-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function IntegrationDirective($compile, $templateCache, $translate, $document, $location, types, utils, toast, integrationService) {

    var linker = function (scope, element) {
        var template = $templateCache.get(integrationFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.integration.httpEndpoint = null;
        if (scope.integration.allowAllPorts == null) {
            scope.integration.allowAllPorts = true;
        }
        if (scope.integration.allowPortsArray == null) {
            scope.integration.allowPortsArray = [];
        }
        if (scope.integration.retryScheme == null) {
            scope.integration.retryScheme = [5, 30, 60];
        }

        var allRetryOptions = [
            {minutes: 5,    label: '5 min'},
            {minutes: 30,   label: '30 min'},
            {minutes: 60,   label: '1 h'},
            {minutes: 120,  label: '2 h'},
            {minutes: 240,  label: '4 h'},
            {minutes: 720,  label: '12 h'},
            {minutes: 1440, label: '24 h'},
            {minutes: 2880, label: '48 h'}
        ];

        function buildRetrySchemeOptions(retryScheme) {
            return allRetryOptions.map(function(opt) {
                return {
                    minutes: opt.minutes,
                    label: opt.label,
                    enabled: retryScheme && retryScheme.indexOf(opt.minutes) !== -1
                };
            });
        }

        scope.retrySchemeOptions = buildRetrySchemeOptions(scope.integration.retryScheme);

        scope.onRetrySchemeChanged = function() {
            scope.integration.retryScheme = scope.retrySchemeOptions
                .filter(function(opt) { return opt.enabled; })
                .map(function(opt) { return opt.minutes; });
        };
        
        scope.$watch('integration', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                scope.retrySchemeOptions = buildRetrySchemeOptions(scope.integration.retryScheme);
            }
            updateHttpEndpoint();
        });

        scope.integrationTypes = [];
        scope.integrationTypes.push(scope.types.integrationType.HTTP);
        scope.integrationTypes.push(scope.types.integrationType.HTTP_V2);
        scope.integrationTypes.push(scope.types.integrationType.TAGO_IO);
        scope.integrationTypes.push(scope.types.integrationType.MQTT);
        scope.integrationTypes.push(scope.types.integrationType.MQTT_V2);
        scope.integrationTypes.push(scope.types.integrationType.MQTT_V2_EMBEDDED);
        scope.integrationTypes.push(scope.types.integrationType.THINGSBOARD);
        scope.integrationTypes.push(scope.types.integrationType.AZURE_IOT_CENTRAL);

        scope.qosValues = [];
        scope.qosValues.push(scope.types.qosValue.AT_MOST_ONCE);
        scope.qosValues.push(scope.types.qosValue.AT_LEAST_ONCE);
        // scope.qosValues.push(scope.types.qosValue.EXACTLY_ONCE);

        function updateHttpEndpoint () {
            if (scope.integration.type == types.integrationType.HTTP_V2.value) {
                refreshHttpEndpoint(scope.types.integrationType.HTTP_V2.value);
            } else {
                refreshHttpEndpoint(scope.types.integrationType.HTTP.value);
            }
        }

        scope.validatePort = function($port) {
            if (!$port) return;
            var portNumber = Number($port);
            if (portNumber < 0 || portNumber > 255) {
                return null;
            }
            // Fix in order to trigger form event on chip modifications
            scope.theForm.$setDirty();
            return portNumber;
        };

        scope.onAllowAllPorts = function() {
            if (scope.integration.allowAllPorts) {
                scope.integration.allowPortsArray = [];
            }
        }

        scope.integrationTypeChanged = () => {
            scope.integration.converterId = null;
            if (!scope.integration.configuration) {
                scope.integration.configuration = {};
            }
            if (scope.integration.type == types.integrationType.HTTP.value) {
                scope.integration.configuration.port = 8080;
                scope.integration.configuration.basePath = '/';
                scope.integration.configuration.authMethod = types.authMethodType.NO_AUTH.value;
                refreshHttpEndpoint(scope.types.integrationType.HTTP.value);
            } else if (scope.integration.type == types.integrationType.HTTP_V2.value) {
                scope.integration.configuration.port = 8080;
                scope.integration.configuration.basePath = '/';
                scope.integration.configuration.authMethod = types.authMethodType.NO_AUTH.value;
                refreshHttpEndpoint(scope.types.integrationType.HTTP_V2.value);
            } else if (scope.integration.type == types.integrationType.TAGO_IO.value) {
                scope.integration.configuration.token = null;
                refreshHttpEndpoint(scope.types.integrationType.HTTP.value);
            } else if (scope.integration.type == types.integrationType.MQTT.value) {
                scope.integration.configuration.port = 1883;
                scope.integration.configuration.ssl = false;
                scope.integration.configuration.retryInterval = 30;
                scope.integration.configuration.token = null;
                scope.integration.configuration.password = null;
            } else if (scope.integration.type == types.integrationType.MQTT_V2.value) {
                scope.integration.configuration.integrationInitializationRetryIntervalS = 120
                scope.integration.configuration.pendingQueueMaxSize = 1000;
                scope.integration.configuration.pendingQueueOnErrorProcessingRetryIntervalS = 60;
                scope.integration.configuration.mqttVersion = null;
                scope.integration.configuration.port = 1883;
                scope.integration.configuration.ssl = false;
                scope.integration.configuration.clientKeyPassword = "";
                scope.integration.configuration.token = null;
                scope.integration.configuration.password = null;
                scope.integration.configuration.autoreconnectIntervalS = 30;
                scope.integration.configuration.connectionTimeoutS = 30;
                scope.integration.configuration.keepAliveIntervalS = 60;
                scope.integration.configuration.cleanSession = false;
                scope.integration.configuration.maxInflight = 5;
                scope.integration.configuration.pushQos = "AT_LEAST_ONCE";
                scope.integration.configuration.pullQos = "AT_LEAST_ONCE";
                scope.integration.configuration.pushRetained = false;
            } else if (scope.integration.type == types.integrationType.MQTT_V2_EMBEDDED.value) {
                // Credentials and topic are auto-generated on the server side; no defaults needed here
            } else if (scope.integration.type == types.integrationType.THINGSBOARD.value) {
                scope.integration.configuration.port = 1883;
                scope.integration.configuration.ssl = false;
                scope.integration.configuration.retryInterval = 30;
                scope.integration.configuration.token = null;
            } else if (scope.integration.type == "AZURE") {
                scope.integration.configuration.retryInterval = 30;
                scope.integration.configuration.token = utils.generateRandomToken(20);
            } else if (scope.integration.type === types.integrationType.AZURE_IOT_CENTRAL.value) {
                refreshHttpEndpoint("AZURE")
                scope.integration.configuration.callbackUrl = $location.protocol() + '://' + $location.host() + scope.integration.httpEndpoint;
            }

        };

        function refreshHttpEndpoint(integrationType) {
            if (scope.integration.configuration) {
                scope.integration.httpEndpoint = integrationService.getIntegrationHttpEndpointLink(
                    integrationType,
                    scope.integration.configuration.routingKey);
            }
            return scope.integration.httpEndpoint;
        }

        $compile(element.contents())(scope);
    };
    return {
        restrict: "E",
        link: linker,
        scope: {
            integration: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/integration/integration.directive.js